module.exports = "//static.hsappstatic.net/website-grader-ui/static-1.8464/img/cta-blobs.png"